import { RESTError } from "../core/RESTError";

/**
 * This error occurs if the generation of a license ended up with an error
 */
export class LicenseGenerationError extends RESTError {}
